import React, { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { apiURL } from "../../../utils/constant";
import { getApiData } from "../../selector/auth.selector";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import { getSelectedVisit } from "../../selector/visits.selector";
import { setVisitPageData } from "../../reducer/visitsDetails.reducer";
import { format } from "date-fns";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";
import { setPageStausData } from "../../reducer/component.reducer";

const usePageStatus = () => {
  const [pageStatus, setPageStatus] = useState();
  const loginData = useSelector(getApiData);
  const subjectId = get(loginData, "SubjectId", "");
  const selectedVisitId = useSelector(getSelectedVisit);
  const dispatch = useDispatch();
  const day = format(new Date(), "dd"); //format == 12%2FMar%2F2024
  const month = format(new Date(), "MMM"); //format == 12%2FMar%2F2024
  const year = format(new Date(), "yyyy"); //format == 12%2FMar%2F2024

  const currentDate = day + "%2F" + month + "%2F" + year;
  const visitId = selectedVisitId?.VisitId;

  const fetchPageStatus = useCallback(async () => {
    try {
      dispatch(showPageLoader());
      const { data } = await Api.get({
        url: apiURL.pageStatus(),
        params: {
          SubjectId: subjectId,
          Date: currentDate,
          VisitId: visitId,
        },
      });

      dispatch(setVisitPageData(data));
      setPageStatus(data);
      dispatch(setPageStausData(data));
      dispatch(hidePageLoader());
    } catch (error) {
      dispatch(hidePageLoader());
      console.log("err==>", error);
    }
  }, [subjectId, currentDate, visitId, selectedVisitId]);

  return {
    pageStatus,
    fetchPageStatus,
  };
};

export default usePageStatus;
